import * as React from 'react'
import 'react-dates/initialize'
import styled, { AnyStyledComponent } from 'styled-components'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { Pagination } from '../../../atoms'
import { BlockedTimeZone } from '../guide_assigns'
import SelectConversationGuide from './SelectConversationGuides'

declare var window: interfaces.IWindow
interface IProps {
  reservationID: any
  for_direct_reservation: boolean
  newGuides: any[]
  newPagination: any
  guideList: any[]
  guideCalendars: any[]
  day: any
  updateGuideList(newGuide, onFinish): void
  onChangePageHandler(page?: number): Promise<any>
}

type GetCalendarData = (
  guideData: any
) => { calendars: any; conflicted: boolean; preAssigned: BlockedTimeZone }

const DEFAULT_GUIDE_CALENDER = {
  am: 'none',
  memo: '',
  pm: 'none',
}

const GuideListModal: React.FC<IProps> = ({
  newGuides,
  newPagination,
  guideList,
  guideCalendars,
  day,
  updateGuideList,
  onChangePageHandler,
}) => {
  const handleAddGuide = newGuide => {
    updateGuideList(newGuide, window.globalModal.closeModal)
  }

  const getCalendarData: GetCalendarData = guideData => {
    const notFound = {
      calendars: null,
      conflicted: false,
      preAssigned: null,
    }
    if (!guideCalendars) {
      return notFound
    }

    const data = guideCalendars.find(
      calendars => calendars.user.id === guideData.id && calendars.day === day
    )

    if (!data) {
      return notFound
    }
    const conflicted =
      data.reservation_user_calendars.length || data.direct_reservation_user_calendars.length
    const preAssigned = data.temporary_assignments.reduce((obj, assignment) => {
      obj[assignment.time_zone] = true
      return obj
    }, {})

    return {
      calendars: data,
      conflicted,
      preAssigned,
    }
  }

  return (
    <S.GuideListModal>
      <div className="guideList">
        {newGuides.length > 0 ? (
          newGuides.map(guideData => {
            const calendarData = getCalendarData(guideData)
            return (
              <SelectConversationGuide
                key={guideData.id}
                calender={calendarData.calendars || DEFAULT_GUIDE_CALENDER}
                guide={guideData}
                addGuide={handleAddGuide}
                hasConversation={
                  guideList.findIndex(
                    conversationGuide => conversationGuide.guide.id === guideData.id
                  ) !== -1
                }
                preAssigned={calendarData.preAssigned}
                conflicted={calendarData.conflicted}
              />
            )
          })
        ) : (
          <div>Guides Not Found</div>
        )}
      </div>
      {newPagination && (
        <Pagination
          currentPage={newPagination.current_page}
          prevPage={newPagination.prev_page}
          nextPage={newPagination.next_page}
          totalPages={newPagination.total_pages}
          totalCount={newPagination.total_count}
          onChangePageHandler={onChangePageHandler}
        />
      )}
    </S.GuideListModal>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.GuideListModal = styled.div`
  .guideList {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 25px;
    padding-top: 25px;
    max-height: 60vh;
    overflow: auto;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      max-height: 400px;
      display: block;
    }
    &::after {
      content: '';
      display: block;
      width: calc(30% - 25px);
      height: 0;
      min-width: 220px;
      max-width: 380px;
    }
  }
`

export default GuideListModal
